import request from '../util/request'

// 注册
export function register(data) {
  return request({
    url: 'pr/_register',
    method: 'post',
    data
  })
}

// 获取注册验证码
export function getRegisterCode(query) {
  return request({
    url: 'pr/registerCode',
    method: 'get',
    params: query
  })
}

// 使用短信验证码登录
export function loginByCode(data) {
  return request({
    url: 'pr/_login_by_verify_code',
    method: 'post',
    data
  })
}

// 使用密码登录
export function loginByPwd(data) {
  return request({
    url: 'pr/oauth/token',
    method: 'post',
    data
  })
}

// 获取登录验证码
export function getLoginCode(query) {
  return request({
    url: 'pr/login_verify_code',
    method: 'get',
    params: query
  })
}

// 获取修改密码的验证码
export function getChangeCode(query) {
  return request({
    url: 'pr/proprietors/_reset-passwordSMS',
    method: 'get',
    params: query
  })
}

// 修改密码
export function changePwd(data) {
  return request({
    url: 'pr/proprietors/_reset-password',
    method: 'post',
    data
  })
}

// 获取当前登录用户的用户信息
export function getUserInfo() {
  return request({
    url: 'pr/proprietors/_show',
    method: 'get'
  })
}

// 上传头像
export function uploadIcon(data) {
  return request({
    url: 'pr/proprietors/_head_portrait',
    method: 'post',
    data
  })
}